'use strict';

angular.module('lmsApp')
    .factory('Authroles', function ($resource) {
        return $resource('api/authroles/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    });
